var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('l-marker',{attrs:{"lat-lng":_vm.latLng,"visible":_vm.isVisible},on:{"ready":function($event){return _vm.$emit('ready', $event)},"click":function($event){return _vm.$emit('click')}}},[_c('l-icon',{attrs:{"icon-anchor":_vm.isPoint ? [20, 41] : [4, 4],"class-name":_vm.isPoint
            ? Object.entries(_vm.iconClasses)
                .filter(function (ref) {
                        var cls = ref[0];
                        var x = ref[1];

                        return x;
})
                .map(function (ref) {
                        var cls = ref[0];

                        return cls;
})
                .join(' ')
            : ''}},[_vm._t("icon")],2),(_vm.popupContent || _vm.$slots.popup)?_c('l-popup',{attrs:{"content":_vm.popupContent,"options":{
            closeButton: false,
            className: 'popup-content',
            autoPan: false,
            autoClose: false
        }}},[_vm._t("popup")],2):_vm._e()],1),_c('l-polyline',{attrs:{"visible":_vm.showLiveTail,"lat-lngs":_vm.polylineLatLangs,"color":'#37474f',"weight":5,"opacity":0.8}}),_c('l-polyline',{attrs:{"visible":_vm.showLiveTail,"lat-lngs":_vm.polylineLatLangs,"color":_vm.deviceColor,"weight":2,"opacity":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }